import * as React from 'react';
import {
  ButtonCallToAction,
  PromptConfirmationModal
} from 'ui';
import { ids } from 'app/area/administration/constants';
import { AdministrationRoleEditProps } from 'app/area/administration/edit/role/types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { shouldDefaultRolePrompt } from 'app/area/administration/edit/role/default-role-prompt';
import { accessDataValidation } from 'app/area/administration/edit/access-data-validation';

export const DefaultRoleButton = (props: AdministrationRoleEditProps) => {
  const {
    accessData, shouldPrompt,
    fetchingSaveRole, optionsFetching,
    data, saveButtonText, editMode,
    translation, markedAsDefaultRole, currentDefaultRole,
    formValues, params: { actionType } = {}, onSave } = props;

  const roleName = !!data?.name ? data.name : !!formValues?.name ? formValues.name : '';

  const saveButton = editMode && <ButtonCallToAction
    id={ids.roles.save_button}
    onClick={onSave}
    disabled={fetchingSaveRole || optionsFetching || !shouldPrompt}>
    {saveButtonText}
  </ButtonCallToAction>;

  const displayConfirmationPrompt = shouldDefaultRolePrompt({
    actionType, formValues, markedAsDefaultRole, currentDefaultRole, data
  }) && !accessDataValidation(accessData, undefined);

  return displayConfirmationPrompt
    ? <div className="d-inline-block">
      <PromptConfirmationModal
        title={translation.default_role_title}
        description={replaceTemplateString(translation.default_role_description, currentDefaultRole?.description, roleName)}
        continueText={translation.save}
        cancelText={translation.cancel}
        onContinue={onSave}>
        {saveButton}
      </PromptConfirmationModal>
    </div> : saveButton;
};
